import { defineStore } from 'pinia'
import cloneDeep from 'lodash.clonedeep'
import { sdk } from '@/components/registration.sdk'
import { freshchat } from '@/components/freshchat'

function shouldIdentifyUser(registrationData) {
  return Boolean(
    registrationData &&
    registrationData.user &&
    registrationData.user.isCompleted,
  )
}

function buildFreshchatProfile(registrationData, hash) {
  const userAttributes =
    (registrationData &&
      registrationData.user &&
      registrationData.user.attributes) ||
    {}
  const individualAttributes =
    (registrationData &&
      registrationData['company-individual'] &&
      registrationData['company-individual'].attributes) ||
    {}
  const businessAttributes =
    (registrationData &&
      registrationData['company-business'] &&
      registrationData['company-business'].attributes) ||
    {}

  const email = userAttributes.email || individualAttributes.email
  const firstName = individualAttributes.first_name || userAttributes.first_name
  const lastName = individualAttributes.last_name || userAttributes.last_name

  const companyName =
    businessAttributes.company_name ||
    businessAttributes.name ||
    userAttributes.company_name ||
    individualAttributes.company_name
  const properties = {}
  if (companyName) properties.cf_company_name = companyName

  return {
    externalId: hash,
    email,
    firstName,
    lastName,
    properties,
  }
}

export const useRegistrationStore = defineStore('registration', {
  state: () => ({
    hash: null,
    type: null,

    /**
     * @type {{token: string, type: string, company: {isCompleted: boolean, errors: [], attributes: {token: null|string}}, counterparty: {}}}
     */
    data: null,
  }),
  getters: {
    getRegistrationDataPart: (state) => (key) => {
      return cloneDeep(state.data[key])
    },
  },
  actions: {
    setRegistrationType(payload) {
      this.type = payload
    },

    getRegistration(payload) {
      this.hash = payload

      return sdk.registration.get(this.hash).then((response) => {
        this.type = response.data.type.toLowerCase()
        this.data = response.data

        if (shouldIdentifyUser(response.data)) {
          freshchat.identify(buildFreshchatProfile(response.data, this.hash))
        }
      })
    },

    updateRegistration() {
      return this.getRegistration(this.hash)
    },

    resetRegistration() {
      this.hash = null
      this.data = null
      this.type = null
    },
  },
})
